import { defaultPinIcon } from 'global/Constants/leafletIcons';
import { FC, useEffect } from 'react';
import { Marker, useMap } from 'react-leaflet';
import { setMap, setMapZoomLevel } from 'redux/reducer/MapReducer/mapReducer';
import { store } from 'redux/store';

interface IMapViewFeatures {
  selectedLocation?: { lat: number; lng: number };
  handleUrl: (_zoomLevel: number, _center: Record<'lat' | 'lng', any>) => void;
}

const TcMapViewFeatures: FC<IMapViewFeatures> = ({ selectedLocation, handleUrl }) => {
  //states
  const map = useMap();

  useEffect(() => {
    store.dispatch(setMap(map));
    map.on('moveend', () => {
      handleUrl(map.getZoom(), map.getCenter());
      store.dispatch(setMapZoomLevel(map.getZoom()));
    });
    return () => {
      map.off('moveend');
    };
  }, [map]);

  return <> {selectedLocation && <Marker icon={defaultPinIcon} position={[selectedLocation.lat, selectedLocation.lng]} />}</>;
};

export default TcMapViewFeatures;
